import { ActionType, getType } from 'typesafe-actions';
import * as complianceActions from './actions';
import { SteelEyeLog, MifidReport } from '@/pages/ComplianceCentre/types'


export type ComplianceCenterActionType = ActionType<typeof complianceActions>;

export interface ComplianceCenterState {

  steelEyeLogs: {
    data: SteelEyeLog[] | null;
    loading: boolean;
  };
  mifidReportV2: {
    data: MifidReport[] | null;
    loading: boolean;
  };
}

const initialState: ComplianceCenterState = {
  steelEyeLogs: { data: null, loading: false },
  mifidReportV2: { data: null, loading: false },
};

const complianceReducer = (
        state: ComplianceCenterState = initialState,
        action: ComplianceCenterActionType,
    ): ComplianceCenterState => {
        switch (action.type) {
    
        
    case getType(complianceActions.getSteelEyeLogs.request):
    return {
        ...state,
        steelEyeLogs: {
        ...state.steelEyeLogs,
        loading: true,
        },
    };

    case getType(complianceActions.getSteelEyeLogs.success):
    return {
        ...state,
        steelEyeLogs: {
        data: action.payload.data,
        loading: false,
        },
    };

    case getType(complianceActions.getSteelEyeLogs.failure):
    return {
        ...state,
        steelEyeLogs: {
        ...state.steelEyeLogs,
        loading: false,
        },
    };

    case getType(complianceActions.getMifidReportV2.request):
      return {
        ...state,
        mifidReportV2: { ...state.mifidReportV2, loading: true },
      };

    case getType(complianceActions.getMifidReportV2.success):
      return {
        ...state,
        mifidReportV2: { data: action.payload.data, loading: false },
      };

    case getType(complianceActions.getMifidReportV2.failure):
      return {
        ...state,
        mifidReportV2: { ...state.mifidReportV2, loading: false },
      };

  
  
      default:
        return state;
    }
  };
  
  export default complianceReducer;